import { render, staticRenderFns } from "./GenerarCurrentAcount.vue?vue&type=template&id=b38f9076&"
import script from "./GenerarCurrentAcount.vue?vue&type=script&lang=js&"
export * from "./GenerarCurrentAcount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports